module.exports = __webpack_public_path__ + "img/dice-3.811b4ae9.png";